import { gql } from '@apollo/client';

export const GET_PRICING_SCHEME_DETAIL = gql`
  query GetPricingSchemeDetail($pricingSchemeId: Long!) {
    getPricingSchemeDetail(pricingSchemeId: $pricingSchemeId) {
      clientId
      pricingSchemeId
      pricingSchemeName
      pricingSchemeDescription
      businessScenario
      bindCount
      priceConfig {
        pricingFeeItemCode
        allPriceConfig {
          primaryFactorConfig
          primaryFactorConfigDesc
          groupId
          contentPriceConfig
        }
      }
      message
      messageKey
      __typename
    }
  }
`;

export interface AllPriceConfigOutput {
  primaryFactorConfig?: string;
  primaryFactorConfigDesc?: string;
  groupId: number;
  contentPriceConfig: string;
  __typename: string;
}

export interface PriceConfigOutput {
  pricingFeeItemCode: number;
  allPriceConfig: AllPriceConfigOutput[];
  __typename: string;
}

export interface PricingSchemeDetailType {
  clientId: number;
  pricingSchemeId?: number;
  pricingSchemeName: string;
  pricingSchemeDescription?: string;
  businessScenario: number;
  bindCount?: number;
  priceConfig: PriceConfigOutput[];
  message?: string | null;
  messageKey?: string | null;
  __typename: string;
}

export interface PricingSchemeDetailResponse {
  getPricingSchemeDetail: PricingSchemeDetailType | null;
}

